'use strict';

module.exports = trimLines;

var ws = /[ \t]*\n+[ \t]*/g;
var newline = '\n';

function trimLines(value) {
  return String(value).replace(ws, newline);
}



//////////////////
// WEBPACK FOOTER
// ./~/trim-lines/index.js
// module id = 317
// module chunks = 96961042003272 139266963665775